/**
 * 防抖指令，可用于表单提交防止重复点击。
 * @type {{inserted: debounce.inserted}}
 */
const debounce = {
  inserted: function (el, binding) {
    let timer;
    el.addEventListener("click", () => {
      // 每次使用前，先清除定时器
      if (timer) clearTimeout(timer);

      // 500毫秒后重新执行
      timer = setTimeout(() => {
        binding.value()
      }, 500)
    })
  }
}

// 导出
export default debounce



// WEBPACK FOOTER //
// ./src/directive/debounce/index.js